module.exports = __webpack_public_path__ + "img/no_upcoming_demand.17d4de7d.svg";